import React from 'react';
import { Container, Toolbar, Typography, Grid } from "@material-ui/core";
import useStyles from 'components/WaterUser/Styles';
// import waterUserImage1 from '../../../assets/shutterstock_1344520172.jpg';
// import waterUserImage2 from '../../../assets/HuhugamHeritageCenter.jpg';
// import waterUserImage3 from '../../../assets/shutterstock_2047410134.jpg';
// import waterUserImage4 from '../../../assets/shutterstock_1307185216.jpg';
import waterUserImage1 from '../../../assets/wateruser-cities.png';
import waterUserImage2 from '../../../assets/wateruser-tribes.png';
import waterUserImage3 from '../../../assets/wateruser-agriculture.png';
import waterUserImage4 from '../../../assets/wateruser-industry.png';
import WaterUserCard from './WaterUserCard';
import { AppRouteURI } from 'router/RoleBasedAccess';

const ChooseWaterUser = () => {
    const classes = useStyles();
    const water_users = [
        { id: 0, img: waterUserImage1, title: 'Cities', desc: "There are around 40 municipal water providers in Central Arizona with access to Colorado River water that is delivered through the Central Arizona Project canal.  See the water supplies they use to meet customer demands, the purposes for which they are used, and how they are impacted by Colorado River shortages.", route: AppRouteURI.WATER_USER + '/cities' },
        { id: 1, img: waterUserImage2, title: 'Tribes', desc: "There are nine Native American Communities in Central Arizona with access to Colorado River water delivered through the Central Arizona Project canal.  See how they are impacted by Colorado River shortages.", route: AppRouteURI.WATER_USER + '/tribes' },
        { id: 2, img: waterUserImage3, title: 'Agriculture', desc: "There are around 15 irrigation districts in Central Arizona with access to Colorado River water delivered through the Central Arizona Project canal.  See the water supplies they use and the purposes for which the water is used.", route: AppRouteURI.WATER_USER + '/agriculture' },
        { id: 3, img: waterUserImage4, title: 'Industry', desc: "There are seven industrial users--such as mines and power companies--with access to Colorado River water delivered through the Central Arizona Project canal.  See how they are impacted by Colorado River shortages.", route: AppRouteURI.WATER_USER + '/industry' },
    ];

    return (
        <Container>
            <Toolbar sx={{ minHeight: 40 }}/>
            <Typography
                component="div"
                variant="h2"
                className={classes.title}
            >
                Choose a Water User
            </Typography>
            <Grid container spacing={3}>
                {
                    water_users.map((water_user) => (
                        <Grid item xs={12} md={3}>
                            <WaterUserCard image={water_user.img} title={water_user.title} desc={water_user.desc} route={water_user.route} />
                        </Grid>
                    ))
                }
            </Grid>
        </Container>
    );
};

export default ChooseWaterUser;